import openclaw from "../img/openclaw-logo-png.jpg"
import tf from "../img/tf-aws-gh.jpg"
import gh from "../img/hg-plus-vault.png"

export let singlePage = true;

export const info = {
    firstName: "AlifDaniel",
    lastName: "Alee",
    miniBio: [
        {
            emoji: '>',
            text: 'AWS Certified Solutions Architect - Associate'
        },
        {
            emoji: '>',
            text: 'Based in Kuala Lumpur, Malaysia'
        },
        {
            emoji: ">",
            text: "Cloud Solutions Specialist at Enfrasys"
        },
        {
            emoji: ">",
            text: "alifdaniel279@gmail.com"
        },
        {
            emoji: ">",
            text: "Cloud • DevOps • Security"
        }
    ],
    socials: [
        {
            link: "https://github.com/4lifdaniel",
            icon: "fa fa-github",
            label: 'github'
        },
        {
            link: "https://www.linkedin.com/in/alifdaniel/",
            icon: "fa fa-linkedin",
            label: 'linkedin'
        },
        {
            link: "https://wa.link/u7fz5a",
            icon: "fa fa-whatsapp",
            label: 'whatsapp'
        },
    ],
    bio: "3+ years of mixed experience in IT infrastructure, cloud computing, security risk and governance in the industry. A long life learner. A sucker for efficiency.",
    portfolio: [
        {
            title: "Automated AWS S3 Deployment via Terraform with HashiCorp Vault Secrets Management",
            // live: "",
            // source: "",
            image: gh,
            description: "Deployed HashiCorp Vault on AWS EC2 to act as a centralized secrets broker, generating short-lived AWS IAM credentials. Integrated GitHub Actions OIDC (JWT auth) so only workflows from a specific GitHub repository can authenticate with Vault. Configured Vault's AWS Secrets Engine with scoped IAM policies. Credentials are auto-expiring (1hr TTL) — dramatically reducing the blast radius of any potential leak. Automated Terraform infrastructure deployment (AWS S3) using injected temporary credentials, with zero manual secrets handling."
        },
        {
            title: "Cloud-Based Static Web Site with IaC and CI/CD",
            live: "https://alifdaniel.com",
            source: "https://alifdaniel.com",
            image: tf,
            description: "Built with React.js and deployed to AWS S3 + CloudFront. Authored Terraform code to define and manage cloud infrastructure, synchronizing IaC with existing AWS configurations. Enabling repeatable environments provisioning."
        },
        {
            title: "Introducing My Slaves",
            live: "https://ultra.alifdaniel.com",
            source: "https://ultra.alifdaniel.com",
            image: openclaw,
            description: "Meet my coworkers/staff/colleague/wtv you wanna call them."
        }
    ]
}
